import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { IconCaretDown, IconCaretUp } from 'components/assets/icons';

/**
 * 
 * @returns 
 */
export const SummaryCard = ({ align = 'left', width = '', title = '', content = '', info = '', upValue = '', downValue = '' }) => {
  return (
    <>
      {align === 'left' && (
        <div style={{ width, whiteSpace: 'nowrap' }}>  
          <div className='summary-label-left'>{title} </div>
          <div className='summary-value-left'>{content} 
            {upValue && <span className='summary-up-value-left'><IconCaretUp />{upValue}</span>}
            {downValue && <span className='summary-down-value-left'><IconCaretDown />{downValue}</span>}
          </div> 
          
        </div>
      )}  
      {align === 'center' && (
        <div style={{ width }}>  
          <div className='summary-label-center'>{title} </div>
          <div className='summary-value-center'>{content}
            {upValue && <span className='summary-up-value-center'><IconCaretUp />{upValue}</span>}
            {downValue && <span className='summary-down-value-center'><IconCaretDown />{downValue}</span>}          
          </div> 
        </div>
      )}        
    </>
  )
};
